export default ({ app }, inject) => {
  const scrollSmooth = () => {
    document.documentElement.style.scrollBehavior = "smooth";
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "unset";
    }, 1000);
  };
  inject("scrollSmooth", scrollSmooth);
};
